import React from "react";

import { Text } from "src/library/components/Text";

export interface NoPriceChangeDataFoundProps {
  name?: string;
}

const NoApprovalChangeDataFound: React.ReactFCWithChildren<NoPriceChangeDataFoundProps> = ({ name }) => {
  return (
    <Text>
      {`No product approval change data ${name ? `associated with ${name}.` : "found."}`}
    </Text>
  );
};

export default NoApprovalChangeDataFound;
